import errorMap from '@gap/backend/util/validations/validation-error-map'
import { z } from 'zod'

export const MindsetCategoryEnums = [
   'business growth',
   'change management',
   'coaching',
   'conflict',
   'core values',
   'leadership',
   'marketing',
   'organisational',
   'performance',
   'sales',
   'systemisation', 
   'time management'
] as const

export const MindsetCategoryEnumsSchema = z.enum(MindsetCategoryEnums, { errorMap })
export type MindsetCategoryEnum = z.output<typeof MindsetCategoryEnumsSchema>

export const MindsetCategoryIconEnums = [
   ...MindsetCategoryEnums,
   'mindset',
   'groups',
   'theater',
   'sign'
] as const

export const MindsetCategoryIconEnumsSchema = z.enum(MindsetCategoryIconEnums, { errorMap })
export type MindsetCategoryIconEnum = z.output<typeof MindsetCategoryIconEnumsSchema>
